import __base_store from '@/store/__base_store'

/**
 * Store de tipos de precio online (modelo `online_price_type`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'online_price_type',
	},
})

